import {DesignCollection} from '../../../stores/DesignCollection';
import {TreeDesignField} from './TreeDesignField';

export class TreeDesignCollection extends DesignCollection {
    insertFields(parentField, children) {
        this.fields.clear();
        let mergeInProgress = false;
        children.forEach(f => {
            if (mergeInProgress) {
                mergeInProgress = false;
                const mergedField = new TreeDesignField(f, parentField);
                mergedField.setCollection(f);
                this.fields[this.fields.length - 1].setMergedField(mergedField);
            } else {
                if (f.merge) {
                    mergeInProgress = true;
                }
                const newField = new TreeDesignField(f, parentField);
                newField.setCollection(f);
                this.fields.push(newField);
            }
        });
    }

    createNewField(data, parentField) {
        return new TreeDesignField(data, parentField);
    }

    //  	get lastLevelFields() {
    // 	return this.getLastLevelFields(this.fields);
    // }

    // getLastLevelFields(fields) {
    //    	let res: any[] = [];
    //     for(let field of fields) {
    //       if(field.collection && field.collection.fields.length) {
    //         res = res.concat(this.getLastLevelFields(field.collection.fields));
    //       }
    //       else {
    //         res.push(field);

    //       }if(field.merge) {
    //           res.push(field.mergedField);
    //         }
    //     }
    //     return res;
    //  	}
}
